import InputMask from 'react-input-mask';

import type { CSSProperties, ChangeEventHandler, ReactNode } from 'react';

import inputClasses from '../Inputs.module.css';

type Props = {
    /** @default '000000000000' */
    placeholder?: string;
    /**
     * @default '+'
     * @example '+61'
     */
    countryCode?: string;
    value?: string;
    onChange?: ChangeEventHandler<HTMLInputElement>;
    disabled?: boolean;
    label?: string | ReactNode;
    marginTop?: CSSProperties['marginTop'];
};

const MobilePhoneInput = (props: Props) => {
    const countryCode = props.countryCode || '+';

    // create an array for the mask, should be country code, followed by a non-zero number, followed by at most 10 numbers
    const nonZeroDigit = /[1-9]/;
    const digits = [...Array(10).keys()];
    const mask = [...countryCode.split(''), nonZeroDigit, ...digits.map(() => /[0-9]/)];

    return (
        <div className={inputClasses.inputGroup} style={{ marginTop: props.marginTop || '' }}>
            {props.label && <label>{props.label}</label>}

            <InputMask
                className={inputClasses.mobilePhoneInput}
                mask={mask}
                placeholder={props.placeholder || '000000000000'}
                maskPlaceholder={null}
                value={props.value?.replace(/\s/g, '')}
                onChange={props.onChange}
                disabled={props.disabled}
            />
        </div>
    );
};

export default MobilePhoneInput;
